import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_GET_REFERENTIEL_DEPARTEMENTS,
    CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
    CONTEXT_GET_REFERENTIEL_PAYS,
    CONTEXT_GET_REFERENTIEL_COMMUNES,
    CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
    CONTEXT_GET_REFERENTIEL_STATUTS_ARMES,
    CONTEXT_GET_REFERENTIEL_ELEMENTS_ARME,
    CONTEXT_GET_METIERS_ET_ASSOCIATIONS_TYPES,
} from '../../constants/apiUrls.constants';

const referentiel = combineReducers({
    pays: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_PAYS),
    communes: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_COMMUNES),
    departements: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_DEPARTEMENTS),
    questionsCompteUsager: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER),
    statutsArmes: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_STATUTS_ARMES),
    typeJustificatifDomicile: APIReducer.bind(
        null,
        CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE,
    ),
    elementsArme: APIReducer.bind(null, CONTEXT_GET_REFERENTIEL_ELEMENTS_ARME),
    metiersEtAssociationsTypes: APIReducer.bind(null, CONTEXT_GET_METIERS_ET_ASSOCIATIONS_TYPES),
});

export default referentiel;
